import { useCallback, useEffect, useRef } from 'react'

import { POPUP_OUTCOMES, PopupOutcomeValue, PopupTypeValue } from '@constants/popupTypes'
import amplitude from '@lib/analytics/amplitude'

export type Screen = 'results' | 'checkout' | 'payment' | 'confirmation' | 'booking'

export const usePopupAnalytics = (popupType: PopupTypeValue, screen: Screen, popupVisible?: boolean) => {
  const hasLoggedVisibleRef = useRef(false)

  const trackPopupVisible = useCallback(() => {
    if (!hasLoggedVisibleRef.current) {
      hasLoggedVisibleRef.current = true
      amplitude.popups.popupVisible(popupType, screen)
    }
  }, [popupType, screen])

  const trackPopupClick = useCallback(
    (ctaLabel: string, popupOutcome: PopupOutcomeValue = POPUP_OUTCOMES.CLOSED) => {
      amplitude.popups.popupClick(popupType, ctaLabel, popupOutcome)
    },
    [popupType],
  )

  const resetVisible = useCallback(() => {
    hasLoggedVisibleRef.current = false
  }, [])

  useEffect(() => {
    if (popupVisible === true) {
      trackPopupVisible()
    } else {
      resetVisible()
    }
  }, [popupVisible, trackPopupVisible, resetVisible])

  return {
    trackPopupClick,
  }
}
